
import { Component, Vue } from 'vue-property-decorator';
import Alert from '~/components/Alerts/Alert.vue';

@Component({ components: { Alert } })
export default class GenericError extends Vue {}
